import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-navy-800 relative border-y border-white/5" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <FadeIn data-id="element-137">
          <div className="prose prose-lg prose-invert mx-auto" data-id="element-138">
            <p className="text-2xl leading-relaxed text-slate-200 font-medium mb-8" data-id="element-139">
              Estás atrapado en un ciclo que parece no tener fin. Tienes el
              talento, tienes la disciplina y tienes una conexión a internet.
              Sin embargo, cada vez que intentas dar el salto al mercado global,
              te chocas contra el mismo muro:{' '}
              <span className="text-accent-400 font-bold" data-id="element-140">
                "Buscamos a alguien con experiencia internacional".
              </span>
            </p>

            <p className="text-xl text-slate-400 mb-12" data-id="element-141">
              ¿Cómo vas a tener esa experiencia si nadie te da la primera
              oportunidad? Mientras tanto, ves pasar los meses con un sueldo
              local que se desvanece frente a la inflación, sabiendo que a pocos
              miles de kilómetros alguien hace tu mismo trabajo por el triple de
              ingresos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}